/**
 * @desc 导出公司油卡列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.OilCompanyCardQueryParameters): Promise<BaseResponse<any>> {
  return fetch({
    url: config.API_HOST + '/base/company/card/export',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
